import { ElMessage } from 'element-plus';
// 统一的筛选错误处理函数
export const handleFilterError = (error) => {
    console.error('Filter error:', error);
    ElMessage.error('筛选条件应用失败，请重试');
};
// 网络请求错误处理
export const handleNetworkError = (error) => {
    console.error('Network error:', error);
    if (error.response) {
        // 服务器响应了错误状态码
        const status = error.response.status;
        switch (status) {
            case 400:
                ElMessage.error('请求参数错误');
                break;
            case 401:
                ElMessage.error('认证失败，请重新登录');
                break;
            case 403:
                ElMessage.error('权限不足');
                break;
            case 404:
                ElMessage.error('请求的资源不存在');
                break;
            case 500:
                ElMessage.error('服务器内部错误');
                break;
            default:
                ElMessage.error(error.response.data?.message || '网络请求失败');
        }
    }
    else if (error.request) {
        // 请求已发出但没有收到响应
        ElMessage.error('网络连接失败，请检查网络');
    }
    else {
        // 其他错误
        ElMessage.error('请求失败，请重试');
    }
};
// 用户认证错误处理
export const handleAuthError = (error) => {
    if (error.response?.status === 401) {
        ElMessage.error('认证失败，请检查用户名和密码');
    }
    else if (error.response?.status === 403) {
        ElMessage.error('账户被禁用，请联系管理员');
    }
    else if (error.response?.status === 429) {
        ElMessage.error('登录尝试过于频繁，请稍后重试');
    }
    else {
        ElMessage.error('登录失败，请稍后重试');
    }
};
// 表单验证错误处理
export const handleValidationError = (error) => {
    console.error('Validation error:', error);
    if (error.response?.data?.errors) {
        // 如果服务器返回了详细的验证错误
        const errors = error.response.data.errors;
        const firstError = Object.values(errors)[0];
        ElMessage.error(firstError);
    }
    else {
        ElMessage.error('表单验证失败，请检查输入');
    }
};
// 通用错误处理函数
export const handleError = (error, context) => {
    console.error(`Error in ${context || 'unknown context'}:`, error);
    // 根据错误类型选择合适的处理方式
    if (error.name === 'ValidationError') {
        handleValidationError(error);
    }
    else if (error.response) {
        handleNetworkError(error);
    }
    else {
        ElMessage.error(error.message || '操作失败，请重试');
    }
};
// 防抖函数工厂
export const createDebounce = (delay = 300) => {
    return (func) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(null, args), delay);
        };
    };
};
// 默认防抖函数
export const debounce = createDebounce();
// 重试机制
export const withRetry = async (fn, maxRetries = 3, delay = 1000) => {
    let lastError;
    for (let i = 0; i < maxRetries; i++) {
        try {
            return await fn();
        }
        catch (error) {
            lastError = error;
            if (i < maxRetries - 1) {
                // 等待一段时间后重试
                await new Promise(resolve => setTimeout(resolve, delay * (i + 1)));
            }
        }
    }
    throw lastError;
};
// 错误边界组件辅助函数
export const createErrorBoundary = (fallbackComponent) => {
    return {
        name: 'ErrorBoundary',
        data() {
            return {
                hasError: false,
                error: null
            };
        },
        errorCaptured(err, vm, info) {
            this.hasError = true;
            this.error = err;
            console.error('Component error boundary caught:', err, info);
            return false;
        },
        render() {
            if (this.hasError) {
                return fallbackComponent;
            }
            return this.$slots.default?.();
        }
    };
};
